<template>
  <div class="browsing-tags">
    <browsing-tag
      v-for="tag in tags"
      :key="tag"
      :name="tag"
      :onClick="clickTag"
      :isSelected="selectedTags.includes(tag)"
      :selectPdf="selectedTags.includes('pdf')"
      :selectEpub="selectedTags.includes('epub')"
    />
  </div>
</template>

<script>
import BrowsingTag from "./BrowsingTag.vue";
export default {
  components: { BrowsingTag },
  name: "BrowsingTags",
  props: ["onChangeTags"],
  data: function () {
    return {
      selectedTags: [],
      selectedLanguages: [],
      tags: [
        "free",
        "kindle-unlimited",
        "verified-purchase",
        "quick-read",
        "most-snaps",
        // "business",
        // "self-help",
        // "health",
        // "mystery",
        // "romance",
      ],
    };
  },

  methods: {
    clickTag(name) {
      if (this.selectedTags.includes(name)) {
        this.selectedTags.splice(this.selectedTags.indexOf(name), 1);
        if (name="free") {
          if (this.selectedTags.includes("pdf")) {
            this.selectedTags.splice(this.selectedTags.indexOf("pdf"), 1);
          }
          if (this.selectedTags.includes("epub")) {
            this.selectedTags.splice(this.selectedTags.indexOf("epub"), 1);
          }
        }
      } else {
        this.selectedTags.push(name);
      }
      //console.log("tags", this.selectedTags);
      this.onChangeTags(this.selectedTags);
    },
  },
};
</script>

<style lang="scss" scoped>
.browsing-tags {
  display: flex;
  flex-wrap: wrap;
  margin-left: 25px;
  max-width: 940px;
  padding-top: 20px;
}

@media (max-width: 1024px) {
  .browsing-tags {
    margin-left: 5px;
  }
}
</style>
